import ViewerDashboard from "../pages/Viewer/Dashboard/ViewerDashboard";

import DashboardIcon from "../assets/images/icons/active/dashboard_white@3x.png";
import InactiveDashboardIcon from "../assets/images/icons/inactive/dashboard dissable@3x.png";
import Profile from "../pages/Viewer/Profile/Profile";
import Banner from "../pages/Viewer/Banners/Banner";
import LotteryBrands from "../pages/Viewer/LotteryBrands/ViewLotteryBrands/LotteryBrands";
import LotteryBrandDays from "../pages/Viewer/LotteryBrandDays/LotteryBrandDays";
import RemainingTickets from "../pages/Viewer/RemainingTickets/RemainingTickets";
import LotteryListing from "../pages/Viewer/LotteryListing/LotteryListing";
import ViewTickets from "../pages/Viewer/LotteryListing/ViewTickets/ViewTickets";
import WinnersList from "../pages/Viewer/WinnersList/WinnersList";
import Inquiries from "../pages/Viewer/Inquiries/Inquiries";
import ViewInquiry from "../pages/Viewer/Inquiries/ViewInquiry/ViewInquiry";
import Payments from "../pages/Viewer/Payments/Payments";
import TicketReports from "../pages/Viewer/TicketReports/TicketReports";

var ViewerRoutes = [
  {
    path: "dashboard",
    name: "Dashboard",
    element: <ViewerDashboard />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brands",
    name: "Lottery Brands",
    element: <LotteryBrands />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "lottery-brand-days",
    name: "Lottery Brand Days",
    element: <LotteryBrandDays />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "banner",
    name: "Banners",
    element: <Banner />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "remaining",
    name: "Remaining Tickets",
    element: <RemainingTickets />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing",
    name: "Lottery Listing",
    element: <LotteryListing />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "winners",
    name: "Winners",
    element: <WinnersList />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries",
    name: "Inquiries",
    element: <Inquiries />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "payments",
    name: "Sales Report",
    element: <Payments />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "ticket-reports",
    name: "Ticket Report",
    element: <TicketReports />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "listing/:id",
    name: "Loterry Listing",
    element: <ViewTickets />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "profile",
    name: "Profile",
    element: <Profile />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
  {
    path: "inquiries/:id",
    name: "Inquiry",
    element: <ViewInquiry />,
    layout: "viewer",
    icon: DashboardIcon,
    inactiveIcon: InactiveDashboardIcon,
  },
];
export default ViewerRoutes;
